module.exports = "/work-site/img/banner-3.9a84b45b.png";